import { lazy } from 'react';
const Overview = lazy(() => import('./overview/Overview'));
const Company = lazy(() => import('./company/Company'));
const User = lazy(() => import('./user/User'));
const Hardware = lazy(() => import('./hardware/Hardware'));
const Settings = lazy(() => import('./tl/settings/Settings'));
const Hierarchy = lazy(() => import('./tl/hierarchy/Hierarchy'));
const Objects = lazy(() => import('./tl/objects/Objects'));
const Workmodes = lazy(() => import('./tl/workmodes/Workmodes'));
const DefaultNotificationPreferences = lazy(() => import('./tl/notifications/DefaultNotificationPreferences'));
const EOSettings = lazy(() => import('./eo/settings/Settings'));

const ABSAdministrationChildsRoutes = [
	{
		id: 'absadmin_overview',
		type: 'item',
		title: "Overview",
		translate: 'OVERVIEW',
		url: '/administration/overview',
		path: '/administration/overview',
		element: <Overview />,
	},
	{
		id: 'absadmin',
		title: 'General',
		translate: 'GENERAL',
		type: 'group',
		url: '',
		children: [
			{
				id: 'absadmin_company',
				type: 'item',
				subicon: 'business',
				title: "Companysettings",
				translate: 'COMPANYSETTINGS',
				url: '/administration/company',
				path: '/administration/company',
				element: <Company />,
			},
			{
				id: 'absadmin_user',
				type: 'item',
				subicon: 'people',
				title: "Usermanagement",
				translate: 'USERMANAGEMENT',
				url: '/administration/user',
				path: '/administration/user',
				element: <User />,
			},
			{
				id: 'absadmin_hardware',
				type: 'item',
				subicon: 'nfc',
				title: "Hardware",
				translate: 'HARDWARE',
				url: '/administration/hardware',
				path: '/administration/hardware',
				element: <Hardware />,
			},
			{
				id: 'absadmin_notificationsettings',
				type: 'item',
				subicon: 'notifications',
				title: "Notification Settings",
				translate: 'NOTIFICATION_DEFAULT_PREFERENCES',
				url: '/administration/notificationsettings',
				path: '/administration/notificationsettings',
				element: <DefaultNotificationPreferences />,
			},
		]
	},
	{
		id: 'tladmin',
		title: 'TimeLite',
		translate: 'TIMELITE',
		type: 'group',
		url: '',
		children: [
			{
				id: 'tladmin_settings',
				type: 'item',
				subicon: 'business_center',
				title: "Settings",
				translate: 'SYSTEMSETTINGS',
				url: '/administration/tl/settings',
				path: '/administration/tl/settings',
				element: <Settings />,
			},
			{
				id: 'tladmin_hierarchy',
				type: 'item',
				subicon: 'account_tree',
				title: "Hierarchy",
				translate: 'MANAGEHIERARCHY',
				url: '/administration/tl/hierarchy',
				path: '/administration/tl/hierarchy',
				element: <Hierarchy />,
			},
			{
				id: 'tladmin_objects',
				type: 'item',
				subicon: 'ballot',
				title: "Objects",
				translate: 'MANAGEOBJECTS',
				url: '/administration/tl/objects',
				path: '/administration/tl/objects',
				element: <Objects />,
			},
			{
				id: 'tladmin_workmodes',
				type: 'item',
				subicon: 'work_outline',
				title: "Workmodes",
				translate: 'MANAGEWORKMODES',
				url: '/administration/tl/workmodes',
				path: '/administration/tl/workmodes',
				element: <Workmodes />,
			},
		]
	},
	{
		id: 'eoadmin',
		title: 'Exkursio',
		translate: 'EXKURSIO',
		type: 'group',
		url: '',
		children: [
			{
				id: 'eoadmin_settings',
				type: 'item',
				subicon: 'business_center',
				title: "Settings",
				translate: 'SYSTEMSETTINGS',
				url: '/administration/eo/settings',
				path: '/administration/eo/settings',
				element: <EOSettings />,
			},
		]
	},
];

export default ABSAdministrationChildsRoutes;
